import React, { useCallback, useEffect, useState } from 'react';
import { useUserInfo, useLocalStorage } from '../../../../hooks';
import SchoolYearSelectBox from './selectBox/SchoolYearSelectBox';
import UnitSelectBox from './selectBox/UnitSelectBox';
import {
  aiBarosamSearchHistoryReg,
  aiBarosamSearchHistorySel
 } from '../../../../api/progressLearningAPI';

function SelectForm({ onSearch }) {
  const [eduCursCd, setEduCursCd] = useState("");
  const [unit, setUnitData] = useState({ unitCd: '', unitNm: '' });
  const { info } = useUserInfo();
  const { userData, setUserData } = useLocalStorage();

  // useEffect(() => {
    /**
     * 해당 페이지에서 뒤로 왔을 때만 파라메터 보존
     */
    //  if (!lastLoaction) return;
    //  const { pathname } = lastLoaction;
    //  if (pathname !== URL.LEARNING.ANSWERING_QUESTIONS
    //   // && pathname !== URL.PROGRESS_LEARNING.AI_BAROSEM
    //   && pathname !== URL.LEARNING.RESULT) {
    //    PARAMS = null;
    //  }
  // }, []);

  useEffect(() => {
    
    const p = userData.gmabp
    if (p) {
      aiBarosamSearchHistoryRegCall({
        eduCursCd: p.eduCursCd,
        unitCd: p.unitCd,
        unitNm: p.unitNm
      }, p);
      setUserData({gmabp: null});
    } else {
      aibarosemSearchHistory();
    }

  }, []);

  const aibarosemSearchHistory = useCallback(async () => {
    const resp = await aiBarosamSearchHistorySel({ type: 'unit', lrnMbrId: info.learnerId });
    if (resp) {
      const code = resp.split(";");

      if (code && code.length === 3) {
        await setEduCursCd(code[0]);
        await setUnitData({ unitCd: code[1], unitNm: code[2] });

        onSearch({
          eduCursCd: code[0],
          unitCd: code[1],
          unitNm: code[2],
          lrnMbrId: info.learnerId,
          language: info.locale,
        });
      }
    }
  }, []);

  const aiBarosamSearchHistoryRegCall = useCallback(async ({
    eduCursCd, unitCd, unitNm
  }, p) => {
    await aiBarosamSearchHistoryReg({
      type: 'unit',
      lrnMbrId: info.learnerId,
      data: `${eduCursCd};${unitCd};${unitNm}`
    });

    if (p) {
      await aibarosemSearchHistory();
    }
  })

  const handleCodeSet = (type, code) => {
    if (type === 'eduCursCd') {
      setEduCursCd(code);
      setUnitData({ unitCd: '', unitNm: '' })
    } else if (type === 'unit') {
      setUnitData(code);
      onSubmit(code);
    }
  };

  const onSubmit = async (pUnit) => {
    const data = {
      lrnMbrId: info.learnerId,
      language: info.locale,
      eduCursCd,
      unitCd: pUnit.unitCd,
      unitNm: pUnit.unitNm,
    }

    await aiBarosamSearchHistoryRegCall({
      eduCursCd,
      unitCd: data.unitCd,
      unitNm: data.unitNm
    })
    
    // setUserData({
    //   gmabp: {
    //     eduCursCd: data.eduCursCd,
    //     unitCd: data.unitCd,
    //     unitNm: data.unitNm
    //   }
    // });
    onSearch(data);
  }

  return (
    <div className="select_wrap wrap2">
      <SchoolYearSelectBox
        defaultValue={eduCursCd}
        handleCodeSet={handleCodeSet}
      />
       <UnitSelectBox
        eduCursCd={eduCursCd}
        defaultValue={unit}
        handleCodeSet={handleCodeSet}
      />
      {/* <div className="area area3">
        <button
          className="btn btn-blue h48"
          onClick={onSubmit}
        >
          확인
        </button>
      </div> */}
    </div>
  );
}

export default SelectForm;